import { apiClient } from "../api/apiClient.js";

const AGENTS_PATH = "/backoffice/agents";

/**
 * P156 frontend for P139A's Agent -> Employer Invite Card endpoints.
 *
 * A separate module from inviteCardsApi.js (worker intake) for the same reason
 * the backend keeps two tables: the owner's rule is that the two sides never
 * mix. A job-side Agent has no worker invite cards at all - the worker create
 * endpoint now refuses it with 409 - and a worker-side Agent has no reason to
 * reach these.
 */
export function listEmployerInviteCards(agentId, { page = 1, pageSize = 25, status, search } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  if (status) {
    params.set("status", status);
  }
  if (search) {
    params.set("search", search);
  }

  return apiClient.get(`${AGENTS_PATH}/${encodeURIComponent(agentId)}/employer-invite-cards?${params.toString()}`);
}

export function createEmployerInviteCard(agentId, body) {
  return apiClient.post(`${AGENTS_PATH}/${encodeURIComponent(agentId)}/employer-invite-cards`, body);
}

/**
 * The Agent's ONE standing EMPLOYER invite link - the job-side twin of
 * inviteCardsApi.ensureStandingInviteLink. A job-side Agent (ฝั่งงาน) recruits
 * employers, so this is the link it copies and sends. Same contract: POST may
 * create a card on first use, but the same agentId always resolves to the same
 * link and a second call never mints a second card.
 */
export function ensureStandingEmployerInviteLink(agentId) {
  return apiClient.post(
    `${AGENTS_PATH}/${encodeURIComponent(agentId)}/employer-invite-cards/standing-link`,
    {}
  );
}

export function revokeEmployerInviteCard(agentId, employerInviteCardId) {
  return apiClient.post(
    `${AGENTS_PATH}/${encodeURIComponent(agentId)}/employer-invite-cards/${encodeURIComponent(employerInviteCardId)}/revoke`,
    {}
  );
}
